module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TD - Chad.3616a6b8.svg";